import React from 'react';

const HomeContext = React.createContext({ evaluationsList: []});
export default HomeContext;